import '@ant-design/v5-patch-for-react-19';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { App as AntdApp } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { App } from 'components/App';
import { store } from 'store';
import { AuthProvider } from 'components/Auth';

import './i18n/i18n';
import './index.scss';

import { MAX_NOTIFICATIONS_COUNT } from './constants-module';
import { InterceptorsProvider } from './components/InterceptorsProvider';

dayjs.extend(utc);
const container = document.getElementById('root')!;

createRoot(container).render(
  <Provider store={store}>
    <AuthProvider>
      <SnackbarProvider
        maxSnack={MAX_NOTIFICATIONS_COUNT}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <InterceptorsProvider>
          <AntdApp>
            <App />
          </AntdApp>
        </InterceptorsProvider>
      </SnackbarProvider>
    </AuthProvider>
  </Provider>,
);
